const $ = jQuery;

$(".scroll-to-reviews").on("click", function (e) {
    e.preventDefault();
    $("html,body").animate(
        {
            scrollTop: $("#reviews").offset().top,
        },
        "2000"
    );
});
